(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-disc-picker-controls')) {
    document.documentElement.setAttribute('data-disc-picker-controls', 'true');
    const expandedDiscPickers = new Set();
    const mobileScrollPositions = new Map();
    let activeDiscPickerSectionId;
    let discPickerZoomOpen = false;

    document.addEventListener(
      'change',
      (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches || !(event.target instanceof Element)) return;

        const discPicker = event.target.closest('.variant-option--disc-images');
        const variantPicker = discPicker?.closest('variant-picker');
        const sectionId = variantPicker?.dataset.sectionId;
        if (!discPicker || !sectionId) return;

        mobileScrollPositions.set(sectionId, {
          x: window.scrollX,
          y: window.scrollY,
        });
      },
      true
    );

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-disc-picker-toggle]');
      if (toggle) {
        const picker = toggle.closest('.variant-option--disc-images');
        if (!picker) return;

        const expanded = picker.classList.toggle('disc-picker--expanded');
        toggle.setAttribute('aria-expanded', String(expanded));

        const variantPicker = toggle.closest('variant-picker');
        const sectionId = variantPicker?.dataset.sectionId;
        if (sectionId) {
          if (expanded) {
            expandedDiscPickers.add(sectionId);
          } else {
            expandedDiscPickers.delete(sectionId);
          }
        }
        return;
      }

      const viewLarger = event.target.closest('[data-disc-picker-view-larger]');
      if (viewLarger) {
        const productSection = viewLarger.closest('.shopify-section, dialog');
        const gallery = productSection?.querySelector('media-gallery');
        const zoomDialog = gallery?.refs?.zoomDialogComponent ?? gallery?.querySelector('zoom-dialog');

        if (zoomDialog && typeof zoomDialog.open === 'function') {
          viewLarger.closest('[data-disc-picker-floating-actions]')?.classList.remove('is-visible');
          activeDiscPickerSectionId = viewLarger.closest('variant-picker')?.dataset.sectionId;
          discPickerZoomOpen = true;
          zoomDialog.classList.add('disc-picker-zoom-fit');
          zoomDialog.querySelectorAll('drag-zoom-wrapper').forEach((wrapper) => {
            if (typeof wrapper.fitToViewport === 'function') wrapper.fitToViewport();
          });
          zoomDialog.open(0, event);
        }
        return;
      }

      const floatingAdd = event.target.closest('[data-disc-picker-add-to-cart]');
      if (floatingAdd) {
        const productSection = floatingAdd.closest('.shopify-section, dialog');
        const nativeAdd = productSection?.querySelector('product-form-component button[name="add"]');

        if (nativeAdd instanceof HTMLButtonElement && !nativeAdd.disabled) {
          floatingAdd.disabled = true;
          floatingAdd.closest('[data-disc-picker-floating-actions]')?.classList.remove('is-visible');
          nativeAdd.click();
        }
        return;
      }

      event.target.closest('[data-disc-picker-dismiss]')
        ?.closest('[data-disc-picker-floating-actions]')
        ?.classList.remove('is-visible');
    });

    window.addEventListener('dialog:close', () => {
      if (!discPickerZoomOpen || !window.matchMedia('(max-width: 749px)').matches) return;

      discPickerZoomOpen = false;
      const variantPicker = Array.from(document.querySelectorAll('variant-picker')).find(
        (picker) => picker.dataset.sectionId === activeDiscPickerSectionId
      );
      variantPicker?.querySelector('[data-disc-picker-floating-actions]')?.classList.add('is-visible');
    });

    document.addEventListener('variant:update', (event) => {
      if (!(event.target instanceof Element)) return;

      const variantPicker = event.target.closest('variant-picker');
      const discPicker = variantPicker?.querySelector('.variant-option--disc-images');
      if (!variantPicker || !discPicker) return;

      const sectionId = variantPicker.dataset.sectionId;
      if (sectionId && expandedDiscPickers.has(sectionId)) {
        discPicker.classList.add('disc-picker--expanded');
        discPicker.querySelector('[data-disc-picker-toggle]')?.setAttribute('aria-expanded', 'true');
      }

      const scrollPosition = sectionId ? mobileScrollPositions.get(sectionId) : undefined;
      if (scrollPosition && window.matchMedia('(max-width: 749px)').matches) {
        const restoreScrollPosition = () => window.scrollTo(scrollPosition.x, scrollPosition.y);
        requestAnimationFrame(() => {
          restoreScrollPosition();
          window.setTimeout(restoreScrollPosition, 50);
        });
        mobileScrollPositions.delete(sectionId);
      }

      document.querySelectorAll('[data-disc-picker-floating-actions].is-visible').forEach((actions) => {
        actions.classList.remove('is-visible');
      });

      const floatingActions = variantPicker.querySelector('[data-disc-picker-floating-actions]');
      if (!floatingActions) return;

      const floatingAdd = floatingActions.querySelector('[data-disc-picker-add-to-cart]');
      if (floatingAdd instanceof HTMLButtonElement) {
        floatingAdd.disabled = event.detail?.resource?.available === false;
      }

      activeDiscPickerSectionId = sectionId;
      floatingActions.classList.add('is-visible');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
